import { TaskChooseOrganization, useAuth } from "@clerk/clerk-react";
import { Box, CircularProgress, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

export default function AuthChooseOrgPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { isLoaded, orgId } = useAuth();
  const [showChooser, setShowChooser] = useState(false);

  // If org is already active (e.g., page revisit), redirect immediately
  useEffect(() => {
    if (isLoaded && orgId) {
      window.location.replace("/");
    }
  }, [isLoaded, orgId]);

  // Brief delay before showing chooser for smoother UX
  useEffect(() => {
    if (isLoaded && !orgId) {
      const timer = setTimeout(() => setShowChooser(true), 500);
      return () => clearTimeout(timer);
    }
  }, [isLoaded, orgId]);

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      {!isMobile && (
        <Box
          sx={{
            flex: 1,
            backgroundColor: "black",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 4,
          }}
        >
          <Stack spacing={4} sx={{ maxWidth: 600, textAlign: "center" }}>
            <Box
              component="img"
              src="/logo-yellow.svg"
              alt="desplega.ai"
              sx={{
                height: 48,
                alignSelf: "center",
                mb: 2,
              }}
            />
            <Typography
              variant="h2"
              sx={{
                fontWeight: 700,
                lineHeight: 1.2,
              }}
            >
              <Box component="span" sx={{ color: "white" }}>
                Almost there!
              </Box>
            </Typography>
            <Typography
              variant="h5"
              sx={{
                color: "rgba(255, 255, 255, 0.7)",
                fontWeight: 400,
                lineHeight: 1.2,
              }}
            >
              Select your workspace to continue. Your testing environment is ready and waiting for
              you.
            </Typography>
          </Stack>
        </Box>
      )}

      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 4,
          backgroundColor: "white",
        }}
      >
        {showChooser ? (
          <TaskChooseOrganization redirectUrlComplete="/" />
        ) : (
          <Stack spacing={3} alignItems="center">
            <CircularProgress size={32} />
            <Typography variant="body1" color="text.secondary">
              Setting up your workspace...
            </Typography>
          </Stack>
        )}
      </Box>
    </Box>
  );
}
